<!--  -->
<template>
  <div
    v-loading="loadingtable"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="链接">
        <el-input v-model="formLabelAlign.linkvalue" placeholder="请输入链接" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">确定导入</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { importoffcount } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        linkvalue: ''
      },
      str: '',
      loadingtable: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    submitForm() {
      if (this.formLabelAlign.linkvalue === '') {
        this.$message.error('请输入要导入的链接')
        return
      }
      this.loadingtable = true
      importoffcount({
        article_url: this.formLabelAlign.linkvalue
      }).then((res) => {
        console.log('res', res)
        // res.data.imgs.forEach(element => {
        //   // eslint-disable-next-line eqeqeq
        //   if (element.type == 'img') {
        //     this.str += `<img src="${element.content}">`
        //   } else {
        //     this.str += `<p>${element.content}</p>`
        //   }
        // })
        // this.$emit('callbackcontent', this.str)
        // this.$emit('callbackcontent', res.data.div)
        // this.$emit('callbackcontent', ' <p style="margin: 0px;padding: 0px;outline: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgb(51, 51, 51);font-family: mp-quote, -apple-system-font, BlinkMacSystemFont,"Helvetica Neue", "PingFang SC" , "Hiragino Sans GB" , "Microsoft YaHei UI" , "Microsoft YaHei" , Arial,sans-serif;font-size: 17px;font-style: normal;font-variant-ligatures: normal;font-variant-caps:normal;font-weight: normal;letter-spacing: normal;orphans: 2;text-align: justify;text-indent:0px;text-transform: none;white-space: normal;widows: 2;word-spacing: 0px;-webkit-text-stroke-width:0px;text-decoration-style: initial;text-decoration-color: initial;"><span style="margin: 0px auto;padding: 0px;outline: none;max-width: 100%;box-sizing: border-box;overflow-wrap: break-word !important;-webkit-tap-highlight-color: transparent;display: block;width: 340px;height: 120px;line-height: 120px;text-align: center;font-size: 18px;color: rgb(107, 107, 107);background: url(https://ziyuan.jingxuansz.com/yangguang/promotion_202212011636552763355.png);background-repeat:no-repeat;background-position: 0px 0px;background-size: 100%;">第一章</span></p>')
        this.$emit('callbackcontent', res.data.div)
        this.$emit('callbacktitle', res.data.title)
        this.$emit('callbackimg', res.data.cover.path, res.data.cover.id)
        this.$emit('callcloser')
        this.loadingtable = false
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
